import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { provideTranslocoScope, TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "app-asset-tabs-header",
    templateUrl: "./asset-tabs-header.component.html",
    styleUrls: ["./asset-tabs-header.component.scss"],
    imports: [TranslocoPipe, MatIconModule],
    providers: [provideTranslocoScope("assetmanagement")],
})
export class AssetTabsHeaderComponent {
    @Input() selectedTab: string;
    @Output() selectedTabChange: EventEmitter<string> = new EventEmitter<string>();

    protected select(tab: string): void {
        this.selectedTabChange.emit(tab);
    }
}
